// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3DWIW","content":"GlobalSearch_content__2eL1D"};